import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { UpdateWarehouseOpeningsComponent } from './crud-article/warehouse-openings/update-warehouse-openings/update-warehouse-openings.component';
import { WarehouseOpeningsComponent } from './crud-article/warehouse-openings/warehouse-openings.component';
import { CrudInventoryReclassificationComponent } from './crud-inventory-reclassification/crud-inventory-reclassification.component';
import { CrudWarehouseOutputAndEntryComponent } from './crud-warehouse-output-and-entry/crud-warehouse-output-and-entry.component';
import { CrudWarehouseTransferComponent } from './crud-warehouse-transfer/crud-warehouse-transfer.component';
import { TransfersComponent } from './crud-transfers/transfers.component';
import { RegisterTreasuryComponent } from './crud-treasury/register-treasury/register-treasury.component';
import { RefundsListComponent } from './refunds/refunds-list/refunds-list.component';
import { RefundsComponent } from './refunds/refunds.component';
import { CrudCustomerSegmentComponent } from './crud-lists/crud-customer-segment/crud-customer-segment.component';
import { ModifyAccountingAccountsComponent } from './crud-lists/crud-accounting-accounts/modify-accounting-accounts/modify-accounting-accounts.component';
import { CrudAccountingAccountsComponent } from './crud-lists/crud-accounting-accounts/crud-accounting-accounts.component';
import { CustomersBySellerComponent } from './export-excel/customers-by-seller/customers-by-seller.component';
import { ModifyActivitiesComponent } from './crud-activities/modify-activities/modify-activities.component';
import { RegisterActivitiesComponent } from './crud-activities/register-activities/register-activities.component';
import { ModifyIcaBasesComponent } from './crud-ica-bases/modify-ica-bases/modify-ica-bases.component';
import { RegisterIcaBasesComponent } from './crud-ica-bases/register-ica-bases/register-ica-bases.component';
import { ModifyDeclarantRateComponent } from './crud-declarant-rate/modify-declarant-rate/modify-declarant-rate.component';
import { RegisterDeclarantRateComponent } from './crud-declarant-rate/register-declarant-rate/register-declarant-rate.component';
import { ModifyPurchaseComponent } from './crud-purchase/modify-purchase/modify-purchase.component';
import { RegisterPurchaseComponent } from './crud-purchase/register-purchase/register-purchase.component';
import { RegistrationModeComponent } from './crud-purchase/registration-mode/registration-mode.component';
import { RegisterProviderComponent } from './crud-provider/register-provider/register-provider.component';
import { ModifyProviderComponent } from './crud-provider/modify-provider/modify-provider.component';
import { CrudMailsHomeComponent } from './crud-lists/crud-mails-home/crud-mails-home.component';
import { DetailPaymentComponent } from './crud-quotation/detail-payment/detail-payment.component';
import { DetailsArticleComponent } from './crud-article/details-article/details-article.component';
import { SelectCurrencyComponent } from './crud-quotation/select-currency/select-currency.component';
import { ExportExcelComponent } from './export-excel/export-excel.component';
import { PayPurchaseComponent } from './crud-purchase/pay-purchase/pay-purchase.component';
import { CrudWarehouseComponent } from './crud-lists/crud-warehouse/crud-warehouse.component';
import { CrudPresentationsComponent } from './crud-lists/crud-presentations/crud-presentations.component';
import { CrudGroupsComponent } from './crud-lists/crud-groups/crud-groups.component';
import { CrudCashiersComponent } from './crud-lists/crud-cashiers/crud-cashiers.component';
import { CrudBanksComponent } from './crud-lists/crud-banks/crud-banks.component';
import { CrudMailsComponent } from './crud-lists/crud-mails/crud-mails.component';
import { CrudPaymentListsComponent } from './crud-lists/crud-payment-lists/crud-payment-lists.component';
import { GetAdressComponent } from './crud-customer/get-adress/get-adress.component';
import { AddCompany } from './authentication/crud-user/modify-user/add-company/add-company.component';
import { VerDebitoComponent } from './fact-notes/debito/ver-debito/ver-debito.component';
import { VerCreditoComponent } from './fact-notes/credito/ver-credito/ver-credito.component';
import { DebitNoteComponent } from './fact-notes/debito/debit-note/debit-note.component';
import { CreditNoteComponent } from './fact-notes/credito/credit-note/credit-note.component';
import { FilterComponent } from './crud-quotation/modify/filter/filter.component';
import { DeliveryComponent } from './crud-quotation/delivery/delivery.component';
import { ModifyArticleComponent } from './crud-article/modify-article/modify-article.component';
import { RegisterArticleComponent } from './crud-article/register-article/register-article.component';
import { ModifySellerComponent } from './crud-seller/modify-seller/modify-seller.component';
import { RegisterSellerComponent } from './crud-seller/register-seller/register-seller.component';
import { ModifyCustomerComponent } from './crud-customer/modify-customer/modify-customer.component';
import { RegisterCustomerComponent } from './crud-customer/register-customer/register-customer.component';
import { ModifyUserComponent } from './authentication/crud-user/modify-user/modify-user.component';
import { RegisterUserComponent } from './authentication/crud-user/register-user/register-user.component';
import { MatButtonModule } from '@angular/material/button';
import { ModifyComponent } from './crud-quotation/modify/modify.component';
import { RegisterComponent } from './crud-quotation/register/register.component';
import { CurrencyComponent } from './currency/currency.component';
import { ProduceCompoundArticleComponent } from './crud-article/produce-compound-article/produce-compound-article.component';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  imports: [
    RegisterComponent,
    ModifyComponent,
    MatDialogModule,
    MatButtonModule,
    RegisterUserComponent,
    ModifyUserComponent,
    RegisterCustomerComponent,
    ModifyCustomerComponent,
    RegisterSellerComponent,
    ModifySellerComponent,
    RegisterArticleComponent,
    ModifyArticleComponent,
    DeliveryComponent,
    FilterComponent,
    CreditNoteComponent,
    DebitNoteComponent,
    VerCreditoComponent,
    VerDebitoComponent,
    AddCompany,
    GetAdressComponent,
    CrudMailsComponent,
    CrudBanksComponent,
    CrudCashiersComponent,
    CrudPaymentListsComponent,
    CrudGroupsComponent,
    CrudPresentationsComponent,
    CrudWarehouseComponent,
    PayPurchaseComponent,
    ExportExcelComponent,
    SelectCurrencyComponent,
    DetailsArticleComponent,
    DetailPaymentComponent,
    CrudMailsHomeComponent,
    ModifyProviderComponent,
    RegisterProviderComponent,
    RegistrationModeComponent,
    RegisterPurchaseComponent,
    ModifyPurchaseComponent,
    RegisterActivitiesComponent,
    ModifyActivitiesComponent,
    RegisterIcaBasesComponent,
    ModifyIcaBasesComponent,
    RegisterDeclarantRateComponent,
    ModifyDeclarantRateComponent,
    CustomersBySellerComponent,
    CrudAccountingAccountsComponent,
    ModifyAccountingAccountsComponent,
    CrudCustomerSegmentComponent,
    RefundsComponent,
    RefundsListComponent,
    RegisterTreasuryComponent,
    TransfersComponent,
    CrudWarehouseTransferComponent,
    CrudWarehouseOutputAndEntryComponent,
    CrudInventoryReclassificationComponent,
    WarehouseOpeningsComponent,
    UpdateWarehouseOpeningsComponent,
    ForgotPasswordComponent,
    CurrencyComponent,
    ProduceCompoundArticleComponent,
  ],
})
export class DialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
  ) {}

  giveCompany(company: string) {}
}
